module.exports = __webpack_public_path__ + "img/formulario.7d8281a6.png";